import type { ICellRendererParams } from 'ag-grid-community';
import { Tooltip } from '@mui/material';
import type { PriceSeries } from '../../schema';

// Single-line truncate; full text on hover. "—" placeholder when empty so
// the column doesn't look broken on series without notes.
export function NotesCell(p: ICellRendererParams<PriceSeries>) {
  const notes = p.data?.notes;
  if (!notes) {
    return <span className="text-border-strong">—</span>;
  }
  return (
    <Tooltip title={notes} arrow placement="top-start">
      <span className="block truncate text-[13px] text-foreground">{notes}</span>
    </Tooltip>
  );
}
